import { AssetsPage } from '@features/assets/components/AssetsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/assets/projector-types')({
    component: () => <AssetsPage kind="projector-types" />,
    staticData: {
        crumb: {
            label: 'Projector types',
        },
    },
})
